import { ComponentPropsWithoutRef, CSSProperties, ReactText } from "react"

import { css, cx } from "@emotion/css"

type TruncatedProps = {
  maxWidth: CSSProperties["maxWidth"]
  children: ReactText
} & ComponentPropsWithoutRef<"span">

export function Truncated(props: TruncatedProps) {
  const { children = "", maxWidth, className, ...rest } = props
  return (
    <span
      title={children.toString()}
      style={{ maxWidth: maxWidth }}
      className={cx(
        css`
          display: block;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        `,
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  )
}
